import React from 'react';
import TopOfNav from "../../layouts/topOfNav/topOfNav.component";
import NavBar from "../../layouts/navbar/navbar.component";
import DrawerNav from "../../components/drawer/drawer.component";
import Footer from "../../layouts/footer/footer.component";
import Axios from 'axios';
import {withRouter} from 'react-router-dom';
import qs from 'query-string'
import {Setting} from "../../setting";
import PaymentLayout from "../../layouts/payment/payment.layout";

class CallBackPage extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            Data : "",
            code : ""
        }
    }

    componentDidMount() {
        const {history} = this.props;
        let x = Setting.apiUrl1 + history.location.pathname + history.location.search;
        let y = qs.parseUrl(x);
        if(y.query.for === "pay") {
            Axios.get(`${Setting.apiUrl}api/payment/get/${y.query.track_code}`)
                .then(res => {
                    this.setState({
                        Data: res.data,
                        code: y.query.track_code
                    })
                })
        } else if (y.query.for === "onlinePay") {
            Axios.get(`${Setting.apiUrl}api/onlineCharge/get/${y.query.track_code}`)
                .then(res => {
                    this.setState({
                        Data: res.data,
                        code: y.query.track_code
                    })
                })
        }
    }

    render() {
        return (
            <div>
                <TopOfNav/>
                <NavBar/>
                <DrawerNav/>
                <PaymentLayout Data={this.state.Data} code={this.state.code} />
                <Footer/>
            </div>
        );
    }
};

export default withRouter(CallBackPage);